import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { isMobile } from 'hooks';
import { formatPrice } from 'utils/helpers';
import { useCostQuery, useListQuery } from 'store/api/shipping-tier';
import {
  Row,
  Col,
  Info,
  Flex,
  Loader,
  InfoBlock,
  SwitchField,
  ErrorMessage,
} from 'components';

import * as Styles from './styles';
import { FormValues } from './types';

export const Package = () => {
  const mobile = isMobile();
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const itemCount = values?.products?.reduce(
    (acc, product) => acc + +product.quantity,
    0
  );

  const {
    isError,
    isLoading,
    isFetching,
    currentData: data,
  } = useCostQuery({ itemCount }, { skip: itemCount < 1 });
  const {
    currentData: tiers,
    isLoading: isTiersLoading,
    isFetching: isTiersFetching,
  } = useListQuery(undefined, {
    skip: !isError || itemCount < 1,
  });
  const matchingTier = tiers?.find(
    ({ minItems, maxItems }) =>
      itemCount >= minItems && (maxItems == null || itemCount <= maxItems)
  );
  const rawPrice = data?.price ?? (isError ? matchingTier?.price : undefined);
  const price =
    rawPrice != null &&
    String(rawPrice).trim() &&
    Number.isFinite(Number(rawPrice)) &&
    Number(rawPrice) >= 0
      ? Number(rawPrice)
      : undefined;
  useEffect(() => {
    setFieldValue('shippingPrice', price ?? '');
  }, [price, itemCount, setFieldValue]);
  const isPending =
    isLoading || isFetching || isTiersLoading || isTiersFetching;

  return (
    <Loader isLoading={isPending}>
      <Styles.Container>
        {!isPending && price === undefined && (
          <ErrorMessage>
            No shipping price is configured for this package. Please ask the
            company owner to check shipping tiers.
          </ErrorMessage>
        )}
        <InfoBlock>
          <Row>
            <Col col={3} colTablet={4}>
              <Info value="USPS Large" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="12”" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="1/4”" title="Package Type" />
            </Col>

            <Col col={3} colTablet={4}>
              <Info value="6”" title="Package Type" />
            </Col>
          </Row>

          <Flex
            gap={24}
            column={mobile}
            alignItems={mobile ? undefined : 'center'}
            justifyContent={mobile ? undefined : 'flex-end'}
          >
            <Flex gap={8} alignItems="center">
              <h4>Price:</h4>
              <h2>{formatPrice(values.shippingPrice)}</h2>
            </Flex>

            <SwitchField name="isFreeShipping" label="Free Shipping" />
          </Flex>
        </InfoBlock>
      </Styles.Container>
    </Loader>
  );
};
